<template>
  <div>
    <div class="main-layout__head main-layout__head_pb24">
      <h2 class="main-title">Probleme</h2>
    </div>

    <div class="main-layout__list main-layout__list_mxh80" v-if="list">
      <div
        class="main-layout__item main-layout__item_hover main-layout__item_head main-layout__item_p12"
      >
        <div class="w-3 t-c foz-23">
          <p>#</p>
        </div>
        <div class="w-5"></div>
        <div class="w-14">
          <p>Grund</p>
        </div>
        <div class="main-layout__item-actions">
          <p>{{$t('listsHeader.actions')}}</p>
          <!-- <div>
              <svg
                @click="fetchById(item.id)"
                width="24px"
                height="24px"
                class="main-layout__item-icon"
              >
                <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
              </svg>
            </div>
            <div>
              <svg
                @click="openDeleteModal(item.id)"
                width="24px"
                height="24px"
                class="main-layout__item-icon"
              >
                <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
              </svg>
            </div>

            <div
              class="administrators-item__delete"
              v-if="$guard('delete', 'Administrators') && item.delete"
            >
              <svg
                @click="confirm(item.id)"
                width="30px"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 492 492"
                style="enable-background:new 0 0 492 492;"
                xml:space="preserve"
                class="main-layout__item-icon"
              >
                <g>
                  <g>
                    <path
                      d="M484.128,104.478l-16.116-16.116c-5.064-5.068-11.816-7.856-19.024-7.856c-7.208,0-13.964,2.788-19.028,7.856
                                    L203.508,314.81L62.024,173.322c-5.064-5.06-11.82-7.852-19.028-7.852c-7.204,0-13.956,2.792-19.024,7.852l-16.12,16.112
                                    C2.784,194.51,0,201.27,0,208.47c0,7.204,2.784,13.96,7.852,19.028l159.744,159.736c0.212,0.3,0.436,0.58,0.696,0.836
                                    l16.12,15.852c5.064,5.048,11.82,7.572,19.084,7.572h0.084c7.212,0,13.968-2.524,19.024-7.572l16.124-15.992
                                    c0.26-0.256,0.48-0.468,0.612-0.684l244.784-244.76C494.624,132.01,494.624,114.966,484.128,104.478z"
                    />
                  </g>
                </g>
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
              </svg>
              <svg
                @click="decline(item.id)"
                width="25px"
                class="dismiss"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512.001 512.001"
                style="enable-background:new 0 0 512.001 512.001;"
                xml:space="preserve"
              >
                <g>
                  <g>
                    <path
                      d="M294.111,256.001L504.109,46.003c10.523-10.524,10.523-27.586,0-38.109c-10.524-10.524-27.587-10.524-38.11,0L256,217.892
                                L46.002,7.894c-10.524-10.524-27.586-10.524-38.109,0s-10.524,27.586,0,38.109l209.998,209.998L7.893,465.999
                                c-10.524,10.524-10.524,27.586,0,38.109c10.524,10.524,27.586,10.523,38.109,0L256,294.11l209.997,209.998
                                c10.524,10.524,27.587,10.523,38.11,0c10.523-10.524,10.523-27.586,0-38.109L294.111,256.001z"
                    />
                  </g>
                </g>
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
              </svg>
          </div>-->
        </div>
      </div>

      <div
        class="main-layout__item main-layout__item_hover main-layout__item_mh"
        v-for="(item, index) in list"
        :key="item.id"
        :class="{
          delete: item.deletion_tag,
        }"
      >
        <div class="w-3 t-c">
          <p>{{ index + 1 }}</p>
        </div>
        <div class="w-5 main-layout__item-image">
          <img :src="item.service.icon" alt />
        </div>
        <div class="w-14">
          <p>{{ item.name }}</p>
        </div>
        <div class="main-layout__item-actions">
          <div v-if="$guard('write', 'Problems')">
            <svg
              @click="editProblemModal(item)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
            </svg>
          </div>
          <div>
            <svg
              @click="openDeleteModal(item.id)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
            </svg>
          </div>

          <div>
            <delete-request
              v-if="$guard('delete', 'Problems') && item.deletion_tag"
              :item="item"
              :type="'client_problems'"
              @save="fetch"
              @remove="deleteOpenAdapter"
            />
          </div>
        </div>
      </div>
    </div>

    <add-btn v-if="$guard('write', 'Problems')" @onClick="openProblemModal" />

    <modal :show="isShowModal" :dark="true" :outside="false" @close="closeTodoListModal">
      <problems-modal @close="closeTodoListModal" @done="done" />
    </modal>

    <modal
      :show="isShowDeleteModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="toggleDeleteModal"
    >
      <delete-modal
        :title="$t('global.areUsure')"
        :cancelDeletionTag="deletionStatus"
        @cancel="toggleDeleteModal"
        @next="deleteConfirm"
      />
    </modal>
  </div>
</template>

<script>
import addBtn from '@/components/controls/addBtn'
import problemsModal from '@/components/modals/problems/problemsModal'
import deleteRequest from '@/components/controls/deleteRequest'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'problemsList',
    components: {
        addBtn,
        problemsModal,
        deleteRequest,
    },
    data() {
        return {
            isShowTodoListModal: false,
            isShowDeleteModal: false,
            isUpdate: false,
        }
    },
    computed: {
        ...mapGetters({
            list: 'problems/list',
            isShowModal: 'problems/isShowModal',
            problem: 'problems/problem',
            deletionStatus: 'problems/deletionStatus',
        }),
    },
    methods: {
        ...mapActions({
            add: 'problems/add',
            update: 'problems/update',
            fetch: 'problems/fetch',
            remove: 'problems/remove',
            requestForDelete: 'deleteControl/requestForDelete',
        }),
        ...mapMutations({
            setState: 'problems/setState',
        }),
        async done() {
            let isOkey

            if (this.isUpdate) {
                isOkey = await this.update(this.problem)
            } else {
                isOkey = await this.add(this.problem)
            }

            if (!isOkey) return

            this.setState({
                key: 'isShowModal',
                data: false,
            })
            await this.fetch()
        },
        editProblemModal(item) {
            this.isUpdate = true
            this.setState({
                key: 'problem',
                data: {
                    name: item.name,
                    service_id: item.service.id,
                    id: item.id,
                },
            })
            this.showTodoListModal()
        },
        openProblemModal() {
            this.isUpdate = false

            this.setState({
                key: 'problem',
                data: {
                    name: '',
                    service_id: null,
                    id: null,
                },
            })

            this.showTodoListModal()
        },
        showTodoListModal() {
            this.setState({
                key: 'isShowModal',
                data: true,
            })
        },
        closeTodoListModal() {
            this.setState({
                key: 'isShowModal',
                data: false,
            })
            this.isUpdate = false
        },
        toggleDeleteModal() {
            this.isShowDeleteModal = !this.isShowDeleteModal
        },
        openDeleteModal(id) {
            this.deletedId = id
            this.toggleDeleteModal()
        },
        deleteOpenAdapter(id) {
            this.openDeleteModal(id)
        },
        async deleteConfirm() {
            if (!this.$guard('delete', 'Problems')) {
                await this.requestForDelete({
                    id: this.deletedId,
                    type: 'client_problems',
                })
                await this.fetch()
                this.toggleDeleteModal()
                return
            }

            await this.remove(this.deletedId)
            await this.fetch()
            this.toggleDeleteModal()
        },
    },
    mounted() {
        this.fetch()
    },
}
</script>
